"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var selectedItemStatus = {
  "WILL_BE_ADDED": "Will be added",
  "WILL_BE_REMOVED": "Will be removed",
  "WILL_BE_AUTO_REMOVED": "Will be auto removed",
  "WILL_BE_REMOVED_WILL_BE_AUTO_REMOVED": "Will be removed will be auto removed",
  "WILL_BE_ADDED_WILL_BE_AUTO_REMOVED": "Will be added will be auto removed",
  "CAN_BE_ADDED": "Can be added"
};
var _default = selectedItemStatus;
exports["default"] = _default;